import { get, getDatabase, onValue, ref } from "firebase/database";
import React, { useEffect, useState } from "react";
import "react-datepicker/dist/react-datepicker.css";
import { auth, db, onAuthStateChanged } from "../../utilities/firebaseConfig";
import { useNavigate } from "react-router-dom";
function Pricing({ isOpen, onClose, children }) {
  const [planpay, setPlanpay] = useState("monthly");
  const navigate = useNavigate();
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }

    return () => {
      document.body.style.overflow = "";
    };
  }, [isOpen]);

  if (!isOpen) return null;
  return (
    <>
      <div className='modal-overlay kjsh' onClick={onClose}>
        <div
          className='modal-content kjabs'
          onClick={(e) => e.stopPropagation()} // Prevent closing on content click
        >
          <button className='modal-close' onClick={onClose}>
            <svg
              xmlns='http://www.w3.org/2000/svg'
              viewBox='0 0 24 24'
              width='32'
              height='32'
              fill='currentColor'
            >
              <path d='M10.5859 12L2.79297 4.20706L4.20718 2.79285L12.0001 10.5857L19.793 2.79285L21.2072 4.20706L13.4143 12L21.2072 19.7928L19.793 21.2071L12.0001 13.4142L4.20718 21.2071L2.79297 19.7928L10.5859 12Z'></path>
            </svg>
          </button>
          <div className='planpagecnt'>
            <h1 className='acntitle'>
              Affordable Plan, Exceptional payment value.
            </h1>
            <p className='acntparag'>
              Simple plans. Simple prices. Only pay for what you really need.
              All plans come with award-winning 24/7 customer support. Prices do
              not include applicable taxes.
            </p>
            <div className='thespac'></div>
            <div className='planselectpay'>
              <div className='planselitem'>
                <div
                  className={`planbx ${planpay === "annually" && "plabx"}`}
                  onClick={() => setPlanpay("annually")}
                ></div>
                <p className='planbxtxt'>Pay annually</p>
              </div>
              <div className='planselitem'>
                <div
                  className={`planbx ${planpay === "semi-annually" && "plabx"}`}
                  onClick={() => setPlanpay("semi-annually")}
                ></div>
                <p className='planbxtxt'>Pay Semi-Annually</p>
              </div>
              <div className='planselitem'>
                <div
                  className={`planbx ${planpay === "quarterly" && "plabx"}`}
                  onClick={() => setPlanpay("quarterly")}
                ></div>
                <p className='planbxtxt'>Pay Quarterly</p>
              </div>
              <div className='planselitem'>
                <div
                  className={`planbx ${planpay === "monthly" && "plabx"}`}
                  onClick={() => setPlanpay("monthly")}
                ></div>
                <p className='planbxtxt'>Pay Monthly</p>
              </div>
            </div>
            <div className='thespacee'></div>
            <div className='plancardscnt'>
              <div className='plancardsitem'>
                <div className='plancardtop'>
                  <h1 className='typcnt execu'>Executive</h1>
                  <div className='thespacesmall'></div>
                  {planpay === "monthly" && <p>₦6,999.99/Month</p>}
                  {planpay === "annually" && <p>₦69,999.99/Annually</p>}
                  {planpay === "semi-annually" && (
                    <p>₦37,999.99/Semi-Annually</p>
                  )}
                  {planpay === "quarterly" && <p>₦19,999.99/Quarterly</p>}
                  <div className='thegap'></div>
                  <button
                    className='selectedplan'
                    onClick={() => navigate("/client/dashboard")}
                  >
                    SELECT
                  </button>
                </div>
                <div className='dividar'></div>
                <div className='thebiggap'></div>
                <div className='plancardbottom'>
                  <div className='plancardbottomcnt'>
                    <p className='plancardword'>
                      4 complimentary services annually, applicable to services
                      valued at up to N20,000 each
                    </p>
                  </div>
                  <div className='plancardbottomcnt'>
                    <p className='plancardword'>
                      Access to premium technician services
                    </p>
                  </div>
                  <div className='plancardbottomcnt'>
                    <p className='plancardword'>
                      Opportunity to purchase or receive exclusive discount
                      vouchers for family and friends
                    </p>
                  </div>
                  <div className='plancardbottomcnt'>
                    <p className='plancardword'>
                      Option to gift services to family and friends
                    </p>
                  </div>
                  <div className='plancardbottomcnt'>
                    <p className='plancardword'>Waived booking fees</p>
                  </div>
                  <div className='plancardbottomcnt'>
                    <p className='plancardword'>
                      Extra 1% discount when you setup automatic payment.
                    </p>
                  </div>
                  <div className='plancardbottomcnt'>
                    <p className='plancardword'>
                      Personalized support to help manage your service requests
                      and ensure a seamless experience.
                    </p>
                  </div>
                </div>
              </div>
              <div className='plancardsitem'>
                <div className='plancardtop'>
                  <h1 className='typcnt golt'>Gold</h1>
                  <div className='thespacesmall'></div>
                  {planpay === "monthly" && <p>₦9,999.99/Month</p>}
                  {planpay === "annually" && <p>₦104,999.99/Annually</p>}
                  {planpay === "semi-annually" && (
                    <p>₦55,999.99/Semi-Annually</p>
                  )}
                  {planpay === "quarterly" && <p>₦28,999.99/Quarterly</p>}
                  <div className='thegap'></div>
                  <button
                    className='selectedplan'
                    onClick={() => navigate("/client/dashboard")}
                  >
                    SELECT
                  </button>
                </div>
                <div className='dividar'></div>
                <div className='thebiggap'></div>
                <div className='plancardbottom'>
                  <div className='plancardbottomcnt'>
                    <p className='plancardword'>
                      6 complimentary services annually, applicable to services
                      valued at up to N20,000 each
                    </p>
                  </div>
                  <div className='plancardbottomcnt'>
                    <p className='plancardword'>
                      Access to premium technician services
                    </p>
                  </div>
                  <div className='plancardbottomcnt'>
                    <p className='plancardword'>
                      Opportunity to purchase or receive exclusive discount
                      vouchers for family and friends
                    </p>
                  </div>
                  <div className='plancardbottomcnt'>
                    <p className='plancardword'>
                      Option to gift services to family and friends
                    </p>
                  </div>
                  <div className='plancardbottomcnt'>
                    <p className='plancardword'>Waived booking fees</p>
                  </div>
                  <div className='plancardbottomcnt'>
                    <p className='plancardword'>
                      Extra 1% discount when you setup automatic payment.
                    </p>
                  </div>
                  <div className='plancardbottomcnt'>
                    <p className='plancardword'>
                      Personalized support to help manage your service requests
                      and ensure a seamless experience.
                    </p>
                  </div>
                  <div className='plancardbottomcnt'>
                    <p className='plancardword'>
                      Same-day service availability
                    </p>
                  </div>
                </div>
              </div>
              <div className='plancardsitem nahism'>
                <div className='plancardtop'>
                  <h1 className='typcnt plati'>Platinum</h1>
                  <div className='thespacesmall'></div>
                  {planpay === "monthly" && <p>₦17,999.99/Month</p>}
                  {planpay === "annually" && <p>₦193,999.99/Annually</p>}
                  {planpay === "semi-annually" && (
                    <p>₦99,999.99/Semi-Annually</p>
                  )}
                  {planpay === "quarterly" && <p>₦51,999.99/Quarterly</p>}
                  <div className='thegap'></div>
                  <button
                    className='selectedplan'
                    onClick={() => navigate("/client/dashboard")}
                  >
                    SELECT
                  </button>
                </div>
                <div className='dividar'></div>
                <div className='thebiggap'></div>
                <div className='plancardbottom'>
                  <div className='plancardbottomcnt'>
                    <p className='plancardword'>
                      10 complimentary services annually, applicable to services
                      valued at up to N30,000 each
                    </p>
                  </div>
                  <div className='plancardbottomcnt'>
                    <p className='plancardword'>
                      Access to premium technician services
                    </p>
                  </div>
                  <div className='plancardbottomcnt'>
                    <p className='plancardword'>
                      Opportunity to purchase or receive exclusive discount
                      vouchers for family and friends
                    </p>
                  </div>
                  <div className='plancardbottomcnt'>
                    <p className='plancardword'>
                      Option to gift services to family and friends
                    </p>
                  </div>
                  <div className='plancardbottomcnt'>
                    <p className='plancardword'>
                      Priority scheduling for all service appointments
                    </p>
                  </div>
                  <div className='plancardbottomcnt'>
                    <p className='plancardword'>
                      Same-day service availability
                    </p>
                  </div>
                  <div className='plancardbottomcnt'>
                    <p className='plancardword'>Waived booking fees</p>
                  </div>
                  <div className='plancardbottomcnt'>
                    <p className='plancardword'>
                      Access to emergency services and extended working hours
                      for convenience.
                    </p>
                  </div>
                  <div className='plancardbottomcnt'>
                    <p className='plancardword'>
                      Personalized support to help manage your service requests
                      and ensure a seamless experience.
                    </p>
                  </div>
                  <div className='plancardbottomcnt'>
                    <p className='plancardword'>
                      Extra 2% discount when you setup automatic payment.
                    </p>
                  </div>
                  <div className='plancardbottomcnt'>
                    <p className='plancardword'>Shopping vouchers</p>
                  </div>
                </div>
              </div>
              <div className='plancardsitem'>
                <div className='plancardtop'>
                  <h1 className='typcnt corp'>Corporate</h1>
                  <div className='thespacesmall'></div>
                  {planpay === "monthly" && <p>₦45,999.99/Month</p>}
                  {planpay === "annually" && <p>₦499,999.99/Annually</p>}
                  {planpay === "semi-annually" && (
                    <p>₦255,999.99/Semi-Annually</p>
                  )}
                  {planpay === "quarterly" && <p>₦131,999.99/Quarterly</p>}
                  <div className='thegap'></div>
                  <button
                    className='selectedplan'
                    onClick={() => navigate("/client/dashboard")}
                  >
                    SELECT
                  </button>
                </div>
                <div className='dividar'></div>
                <div className='thebiggap'></div>
                <div className='plancardbottom'>
                  <div className='plancardbottomcnt'>
                    <p className='plancardword'>
                      15 complimentary services annually, applicable to services
                      valued at up to ₦50,000 each
                    </p>
                  </div>
                  <div className='plancardbottomcnt'>
                    <p className='plancardword'>
                      Accesss exclusive pricing and discount structures.
                    </p>
                  </div>
                  <div className='plancardbottomcnt'>
                    <p className='plancardword'>
                      Enjoy expedited service and priority booking, ensuring
                      minimal disruption to your business operations.
                    </p>
                  </div>
                  <div className='plancardbottomcnt'>
                    <p className='plancardword'>
                      Benefit from a network of vetted and experienced
                      technicians specializing in a variety of handyman
                      services.
                    </p>
                  </div>
                  <div className='plancardbottomcnt'>
                    <p className='plancardword'>
                      Tailor service plans to meet the specific needs of your
                      corporate facilities and workforce.
                    </p>
                  </div>
                  <div className='plancardbottomcnt'>
                    <p className='plancardword'>
                      Choose from various membership plans that offer
                      predictable budgeting and reduced upfront costs.
                    </p>
                  </div>
                  <div className='plancardbottomcnt'>
                    <p className='plancardword'>
                      Experience consistent, high-quality work supported by
                      rigorous service standards and quality control.
                    </p>
                  </div>
                  <div className='plancardbottomcnt'>
                    <p className='plancardword'>
                      Access to rapid response services for urgent repairs or
                      maintenance issues, reducing downtime.
                    </p>
                  </div>
                  <div className='plancardbottomcnt'>
                    <p className='plancardword'>
                      Dedicated account managers who ensure efficient service
                      coordination and personalized support.
                    </p>
                  </div>
                  <div className='plancardbottomcnt'>
                    <p className='plancardword'>
                      Leverage additional benefits like bundled services,
                      seasonal promotions, and comprehensive maintenance
                      programs.
                    </p>
                  </div>
                  <div className='plancardbottomcnt'>
                    <p className='plancardword'>
                      Extra 5% discount when you setup automatic payment.
                    </p>
                  </div>
                  <div className='plancardbottomcnt'>
                    <p className='plancardword'>
                      Tailor service plans to fit specific needs, whether for
                      residential or corporate environments.
                    </p>
                  </div>
                  <div className='plancardbottomcnt'>
                    <p className='plancardword'>
                      Enjoy longer warranty periods and enhanced service
                      guarantees on all projects.
                    </p>
                  </div>
                  <div className='plancardbottomcnt'>
                    <p className='plancardword'>
                      These benefits are designed to optimize operational
                      efficiency, enhance workplace safety, and deliver
                      long-term value for corporate clients.
                    </p>
                  </div>
                  <div className='plancardbottomcnt'>
                    <p className='plancardword'>
                      Access special events, promotions, and early
                      product/service previews
                    </p>
                  </div>
                  <div className='plancardbottomcnt'>
                    <p className='plancardword'>
                      Free monthly property maintenance tips and webinars{" "}
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className='thespacee'></div>
            <div className='thespacee'></div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Pricing;
